import { AppBox } from "../../../../../commons/components";

export default function MatchCommentaryDelete() {
  return (
    <AppBox displayBlock>
      Do you want to delete this commentary permanently? Once you delete it, the action cannot be undone.
    </AppBox>
  );
}
